import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import Help from 'components/Help/Help';
import ContentGenerator from 'components/ContentGenerator/ContentGenerator';

export function ProductServicesTooltip(props) {
	const { item, onClick, tooltipTextProp } = props;
	const tooltip = get(item, 'tooltip');
	if (!tooltip) {
		return null;
	}
	let tooltipConfig = [
		{
			type: 'markdown',
			data: tooltip
		}
	];
	if (tooltip.substring(0, 2) === '@@') {
		const tooltipPath = tooltip.substring(2);
		const content = get(tooltipTextProp, tooltipPath);

		if (!content) {
			return null;
		}
		tooltipConfig = [
			{
				type: 'markdown',
				data: content
			}
		];
		const contentTable = get(tooltipTextProp, tooltipPath + '_TABLE');
		if (contentTable) {
			try {
				tooltipConfig.unshift({
					type: 'table',
					data: JSON.parse(contentTable)
				});
			} catch (e) {
				throw new Error(e);
			}
		}
	}
	return (
		<Help position="bottom-left" className={props.className} onClick={onClick}>
			<ContentGenerator config={tooltipConfig} />
		</Help>
	);
}
const mapStateToProps = state => ({
	tooltipTextProp: get(state, ['config', 'data', 'tooltip-zion-services'])
});
export default connect(mapStateToProps)(ProductServicesTooltip);
